import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalKasirPageRoutingModule } from './modal-kasir-routing.module';

import { ModalKasirPage } from './modal-kasir.page';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalKasirPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ModalKasirPage],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ModalKasirPageModule {}
